import { ProtocolVersionLastNonrootItemsKey, ProtocolVersionLatest, compareVersions } from '@standardnotes/common';
import { CreateDecryptedItemFromPayload, DecryptedPayload, FillItemContentSpecialized, PayloadTimestampDefaults, } from '@standardnotes/models';
import { UuidGenerator } from '@standardnotes/utils';
import { ContentType } from '@standardnotes/domain-core';
/**
 * Creates a new random items key to use for item encryption, and adds it to model management.
 * Consumer must call sync. If the protocol version <= 003, only one items key should be created,
 * and its .itemsKey value should be equal to the root key masterKey value.
 */
export class CreateNewDefaultItemsKey {
    constructor(mutator, items, operators, rootKeyManager) {
        this.mutator = mutator;
        this.items = items;
        this.operators = operators;
        this.rootKeyManager = rootKeyManager;
    }
    async execute() {
        const rootKey = this.rootKeyManager.getSureRootKey();
        const operatorVersion = rootKey ? rootKey.keyVersion : ProtocolVersionLatest;
        let itemTemplate;
        if (compareVersions(operatorVersion, ProtocolVersionLastNonrootItemsKey) <= 0) {
            /** Create root key based items key */
            const payload = new DecryptedPayload({
                uuid: UuidGenerator.GenerateUuid(),
                content_type: ContentType.TYPES.ItemsKey,
                content: FillItemContentSpecialized({
                    itemsKey: rootKey.masterKey,
                    dataAuthenticationKey: rootKey.dataAuthenticationKey,
                    version: operatorVersion,
                }),
                ...PayloadTimestampDefaults(),
            });
            itemTemplate = CreateDecryptedItemFromPayload(payload);
        }
        else {
            /** Create independent items key */
            itemTemplate = this.operators.operatorForVersion(operatorVersion).createItemsKey();
        }
        const itemsKeys = this.items.getDisplayableItemsKeys();
        const defaultKeys = itemsKeys.filter((key) => {
            return key.isDefault;
        });
        for (const key of defaultKeys) {
            await this.mutator.changeItemsKey(key, (mutator) => {
                mutator.isDefault = false;
            });
        }
        const itemsKey = await this.mutator.insertItem(itemTemplate);
        await this.mutator.changeItemsKey(itemsKey, (mutator) => {
            mutator.isDefault = true;
        });
        return itemsKey;
    }
}
